<a
	*ngIf="user"
	class="user-picture"
	[ngStyle]="{
		'background-image': 'url(' + getPictureUrl() + ')'
	}"
	title="{{ user.fullname }}"
	href="/users/{{ user.id }}"
></a>
